import apiClient from '@/services/rest-api-sms/apiClient'

const baseEndpoint = '/training-dataset'

export const getSummary = async () => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/summary`,
  })

  return response?.data
}

export const update = async (id, data) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}`,
    data,
  })

  return response?.data
}

export const createBulk = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}/bulk`,
    data,
  })

  return response
}

export const updateBulk = async (data) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/bulk`,
    data,
  })

  return response
}

export const get = async (queryParam) => {
  const params = {
    page: queryParam?.page || undefined,
    limit: queryParam?.limit || undefined,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    params: params,
  })

  return response?.data
}
